import { DesignSystem, DesignSystemAccessMode, ObjectMeta } from "@supernova-studio/model";
import { z } from "zod";

export const DTODesignSystemUpdateInput = DesignSystem.partial()
  .omit({
    id: true,
    workspaceId: true,
    createdAt: true,
    updatedAt: true,
    docSlug: true,
    docViewUrl: true,
    accessMode: true,
  })
  .extend({
    meta: ObjectMeta.partial().optional(),
  });

export const DTODesignSystemUpdateAccessModeInput = z.object({
  accessMode: DesignSystemAccessMode,
  retain: z
    .object({
      userIds: z.string().array(),
      inviteIds: z.string().array(),
    })
    .optional(),
});

export type DTODesignSystemUpdateInput = z.infer<typeof DTODesignSystemUpdateInput>;
export type DTODesignSystemUpdateAccessModeInput = z.infer<typeof DTODesignSystemUpdateAccessModeInput>;
